// main.js
import { createApp } from 'vue';
import App from '@/App.vue'
import './tailwind.css'
import router from './routes';
import store from './store';
import vue3GoogleLogin from 'vue3-google-login';
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import VueCookie from 'vue-cookies'
import 'primevue/resources/themes/lara-dark-indigo/theme.css' // theme
import 'primevue/resources/primevue.min.css' // core css
import 'primeicons/primeicons.css' // icons
import PrimeVue from 'primevue/config'
import ProgressSpinner from 'primevue/progressspinner'

const vuetify = createVuetify({
  components,
  directives,
})
const CLIENT_ID = '376128556904-bpfa0hu6nhuj5mer32atd8likj4cbcq4.apps.googleusercontent.com';
const app = createApp(App).use(vuetify);

app.use(store);
app.use(router);
app.use(VueCookie);
app.use(vue3GoogleLogin, {
    clientId: CLIENT_ID
    });
app.use(PrimeVue, {
    components: {
        ProgressSpinner
    }
});
app.mount('#app')